import React from 'react';
import './LandingPage.css';
import Seo from '../global/Seo';
import OnboardingWizard from './OnboardingWizard';
import { GLOBAL_PLAN_ORDER } from '../settings/ManageCompany/wizardConfig';

/**
 * Public /get-started page — the onboarding wizard rendered as its own full
 * page (with a back arrow) instead of a modal overlay, so it never covers the
 * marketing content. A pre-selected plan arrives as ?plan=<id>; the back arrow
 * (and the wizard's own back/close controls) return to the landing page.
 */
class GetStarted extends React.Component {
  planFromQuery() {
    try {
      const search =
        (this.props.location && this.props.location.search) ||
        window.location.search;
      const plan = new URLSearchParams(search).get('plan');
      return plan && GLOBAL_PLAN_ORDER.includes(plan) ? plan : null;
    } catch (e) {
      return null;
    }
  }

  // Where "back"/close returns to. When the user arrived from the login page
  // (?from=login) send them back to /login; otherwise default to the landing
  // page.
  backTarget() {
    try {
      const search =
        (this.props.location && this.props.location.search) ||
        window.location.search;
      return new URLSearchParams(search).get('from') === 'login'
        ? '/login'
        : '/';
    } catch (e) {
      return '/';
    }
  }

  back = () => {
    const target = this.backTarget();
    if (this.props.history) this.props.history.push(target);
    else window.location.assign(target);
  };

  render() {
    return (
      <>
        <Seo
          title="Get Started"
          description="Start your NuVe System free trial. Pick a plan and set up memberships, employees, reporting, payouts, and security for your game room in minutes."
          path="/get-started"
        />
        <OnboardingWizard
          open
          initialPlanId={this.planFromQuery()}
          history={this.props.history}
          onClose={this.back}
        />
      </>
    );
  }
}

export default GetStarted;
